"use client";

import StatusContainer from "@/components/containers/status-container";
import TrackingEvent from "@/components/events/tracking-event";
import { NavButton } from "@/components/nav-button";
import { getGtmPurchaseEventProps } from "@/lib/checkout/gtm";
import {
  clearGiftingDetailsDraft,
  notifyGiftingQuantityChanged,
} from "@/components/membership-gifting/gifting-form/form-options";
import { clearGiftingBillingDetailsDraft } from "@/components/membership-gifting/gifting-billing-details-form/form-options";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

type GiftingPaymentSuccessProps = {
  giftingLandingPathname: string;
  purchaseEventProps: ReturnType<typeof getGtmPurchaseEventProps>;
};

function GiftSuccessIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-full w-full"
      fill="none"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" fill="#050033" r="28" />
      <path
        d="m17.5 29 7 7L39 20"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </svg>
  );
}

export function GiftingPaymentSuccess({
  giftingLandingPathname,
  purchaseEventProps,
}: GiftingPaymentSuccessProps) {
  const t = useTranslations("MembershipGifting.success");

  useEffect(() => {
    clearGiftingDetailsDraft();
    clearGiftingBillingDetailsDraft();
    notifyGiftingQuantityChanged();
  }, []);

  return (
    <>
      <StatusContainer
        heading={t("heading")}
        title={t("eyebrow")}
        desc={t("description")}
        icon={<GiftSuccessIcon />}
        button={
          <NavButton href={giftingLandingPathname}>{t("button")}</NavButton>
        }
      />
      <TrackingEvent eventName="purchase" eventProps={purchaseEventProps} />
    </>
  );
}
